/**
 * Acciones del autorizador / mesa de control · autorizar, rechazar para
 * corrección, dar de baja terminal.
 *
 * El endpoint `reenviar` (cuando el solicitante corrige y reenvía) vive
 * aparte porque lo dispara el solicitante, no el autorizador.
 */
import { axiosClient } from "@/shared/api/axios-client";
import type { SolicitudDetalle } from "@/lib/types";

/**
 * Autoriza el nivel actual. En el ÚLTIMO nivel (Mesa de Control) se debe enviar
 * `fechaPago` (ISO `YYYY-MM-DD`); en niveles intermedios se omite.
 */
export async function autorizarSolicitud(
  id: string,
  fechaPago?: string | null
): Promise<SolicitudDetalle> {
  const { data } = await axiosClient.post<SolicitudDetalle>(
    `/api/autorizacion/${id}/autorizar`,
    { fechaPago: fechaPago ?? null }
  );
  return data;
}

export async function rechazarSolicitud(
  id: string,
  motivos: string[]
): Promise<SolicitudDetalle> {
  const { data } = await axiosClient.post<SolicitudDetalle>(
    `/api/autorizacion/${id}/rechazar`,
    { motivos }
  );
  return data;
}

export async function darDeBajaSolicitud(
  id: string,
  motivos: string[]
): Promise<SolicitudDetalle> {
  const { data } = await axiosClient.post<SolicitudDetalle>(
    `/api/autorizacion/${id}/dar-de-baja`,
    { motivos }
  );
  return data;
}
